<template>
  <div class="container">
    <loading v-model:active="loading" />
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop">
        <div class="animate__fadeInDown animate__animated">
          <div class="modal-wrapper">
            <div class="modal-dialogs" role="document">
              <div class="modal-content modal-xs">
                <h1 class="tm5 modal-title d-inline-block">Save config</h1>
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross text-right close-modal"
                  @click="hideModal($event)"
                  >&times;</a
                >

                <div class="modal-body mdScroll px-5 pb-5">
                  <div class="main-rpc-modal">
                    <input type="text" name="asset_t" v-model="asset_t" placeholder="Enter Asset template id">
                    <select v-model="type">
                      <option value="craft">Craft Config</option>
                      <option value="upgrade">Upgrade Config</option>
                    </select>
                    <template v-if="type=='craft'">
                    <div
                      v-for="(itemList, index) in configMap" :key="index"
                    >
                      <select v-model="configMap[index].key">
                        <option value="WWS" @click.prevent="setItem('WWS',false)">WWS Token</option>
                        <option value="WWG" @click.prevent="setItem('WWG',false)">WWG Token</option>
                        <option v-for="(opt,code) in gameItems" :key="code" :value="code" @click.prevent="setItem(code,index)">{{opt}}</option>
                      </select>
                      <input type="text" v-model="configMap[index].value" placeholder="Enter value">
                    </div>
                    </template>
                    <template v-else>
                    <div>
                      <select v-model="configMap[0].key" v-if="type=='craft'">
                        <option v-for="(opt,code) in gameItems" :key="code" :value="code" @click.prevent="setItem(code,index)">{{opt}}</option>
                      </select>
                      <input type="number" v-model="configMap[0].value" placeholder="Define per level price">
                      <!-- <p class="text-warning">Price should have token symbol, and 4 decimal places</p> -->
                    </div>
                    </template>
                    <button @click="addRow()" class="submit"  v-if="type=='craft'">Add row</button>
                    <div class="text-center w-100 attack_btn mt-3">
                      <button @click="saveConfig()">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-loading-overlay/dist/vue-loading.css";
import ApiService from "@/services"
export default {
  name: "Config",
  components: {
    Loading,
  },
  props: ["error", "showModel"],
  showModal: true,
  data() {
    return {
      amount: null,
      token: false,
      loading: false,
      type: "craft",
      asset_t: "",
      walletBalance: null,
      gameItems:{},
      configMap:[
        {value:"",key:"1"},
        {value:"",key:""},
        {value:"",key:""},
        {value:"",key:""},
      ]
    };
  },
  created() {
    this.gameItems = ApiService.gameItemList();
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    setItem(code,index){
      if(!index){
        this.configMap.push({key:code});
      }
      this.configMap[index].key=code;
    },
    addRow(){
      this.configMap.push({value:"",key:""});
    },
    async saveConfig() {
      if(!this.asset_t){
        ApiService.errorMsg("Please provide template id of the gun.");
      }else{
        const configData = this.configMap.filter((i)=>i.key && i.value);
        this.loading = true;
        const data = {
          contract: process.env.VUE_APP_CONTRACT,
          action: "save.config",
          data: {
            asset_t: this.asset_t,
            type: this.type,
            config:configData
          },
        };
        await ApiService.transaction(
          data,
          (res) => {
            if (res.processed) {
              ApiService.successMsg();
              this.loading = false;
            }
          },
          (error) => {
            ApiService.errorMsg(error);
            this.loading = false;
          }
        );
      }
    },
  },
};
</script>
  
  <style scoped>
.progress-cont .progress__bar {
  height: 9px !important;
}
input,select{
  background-color: #303245;
    border-radius: 5px;
    border: 0;
    box-sizing: border-box;
    color: #eee;
    font-size: 18px;
    height: 100%;
    outline: 0;
    padding: 3px 20px 3px;
    width:42%;
    margin: 3px;
}
.submit {
  background-color: rgb(1, 160, 91);;
  border-radius: 8px;
  border: 0;
  box-sizing: border-box;
  color: #eee;
  cursor: pointer;
  font-size: 14px;
  height: 40px;
  margin-top: 18px;
  text-align: center;
  width: 20%;
}

.submit:active {
  background-color: rgb(1, 160, 91);
}
.modal-wrapper .modal-content {
    /* opacity: 0.9; */
    text-align: center;
    margin: auto;
    padding: 70px 20px;
    background: #000000;
    border-radius: 46px !important;
    border-width: initial !important;
    border-style: none !important;
    border-color: initial !important;
    border-image: initial !important;
    border: 3px solid #EEAC33 !important;
    height: 100%;
}

</style>
  